import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [""]
  
  connect() {
    this.active = false
    document.addEventListener('filter-item:open', this.hideFilterItems)
    document.addEventListener('filter-item:close', this.showFilterItems)
  }

  disconnect() {
    document.removeEventListener('filter-item:open', this.hideFilterItems)
    document.removeEventListener('filter-item:close', this.showFilterItems)
  }

  show = (event) => {
    this.active = true
    this.element.classList.add("active")
    document.dispatchEvent(new CustomEvent('filter:show', { detail: { active: this.active } }))
  }

  close = (event) => {
    this.active = false
    this.element.classList.remove("active")
    document.dispatchEvent(new CustomEvent('filter:close', { detail: { active: this.active } }))
  }

  hideFilterItems = (event) => {
    this.active = true
    this.element.classList.add("hide")
  }

  showFilterItems = (event) => {
    this.active = false
    this.element.classList.remove("hide")
  }
 }
